// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gag4octPqpYww5ViXeVh{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);cursor:default;border-radius:6px;align-items:center;min-width:0;max-width:100%;height:24px;padding:0 0 0 8px;display:flex}.XsKwKx5NKYsRmlfTqKu1{padding:0 8px}.jgNdCKQxIl4nR3HT94rz{margin-right:8px}.I9uex2aJlccLM0cCYvo7{color:var(--content-primary-primary);white-space:nowrap;text-overflow:ellipsis;font-size:13px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `gag4octPqpYww5ViXeVh`,
	"item--readOnly": `XsKwKx5NKYsRmlfTqKu1`,
	"itemReadOnly": `XsKwKx5NKYsRmlfTqKu1`,
	"item__avatar": `jgNdCKQxIl4nR3HT94rz`,
	"itemAvatar": `jgNdCKQxIl4nR3HT94rz`,
	"item__name": `I9uex2aJlccLM0cCYvo7`,
	"itemName": `I9uex2aJlccLM0cCYvo7`
};
export default ___CSS_LOADER_EXPORT___;
